
import {Component, Prop, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import UiIcon from '@/components/common/UiIcon.vue'

const refModule = namespace('ref')

@Component({components: {UiIcon}})
export default class RefMultiSelect extends Vue {
  @Prop(String) name!: string
  @Prop(String) label!: string
  @Prop({type: Array, default: () => []}) value!: Array<string | number>
  @refModule.Getter('refGetter') refObject: any
  @refModule.Action('getRefAction') getRef: any

  get options() {
    return this.refObject[this.name] || []
  }

  get selectionLabel() {
    const selected = this.options.filter((option) => this.isSelected(option.CODE))
    if (!this.value.length) return 'Tous'
    if (this.value.length === 1 && selected.length) return selected[0].LIBELLE
    return `${this.value.length} sélectionnés`
  }

  isSelected(code) {
    return this.value.some((value) => String(value) === String(code))
  }

  toggle(code) {
    this.$emit(
      'input',
      this.isSelected(code) ? this.value.filter((value) => String(value) !== String(code)) : [...this.value, code]
    )
  }

  close() {
    const dropdown = this.$refs.dropdown as HTMLDetailsElement
    dropdown.open = false
    const summary = dropdown.querySelector('summary')
    if (summary) summary.focus()
  }

  onOutsideClick(event: MouseEvent) {
    if (!this.$el.contains(event.target as Node)) (this.$refs.dropdown as HTMLDetailsElement).open = false
  }

  mounted() {
    if (!this.refObject[this.name]) this.getRef(this.name)
    document.addEventListener('click', this.onOutsideClick)
  }

  beforeDestroy() {
    document.removeEventListener('click', this.onOutsideClick)
  }
}
